import { useEffect, useState, useContext } from 'react';
import Spinner from '../../UI/Modal/Spinner';
import { urls } from './api/urls';
import ZaglavljeFilter from './components/ZaglavljeFilter';
import useHttp from '../../../hooks/use-http';
import GridProviderPonude from './components/GridProviderPonude';
import { formatDateBody } from '../../../../utils/FormatDate';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import Inputs from './components/Inputs';
import toast from 'react-hot-toast';
import { handleErrorMessage } from '../../../../shared/api/handleErrorMessage';
import { TabContext } from '../../../Context/TabContext';
import { useTranslation } from 'react-i18next';

const INITIAL_VALUES_FILTER = {
  datumOd: new Date(new Date().setMonth(new Date().getMonth() - 1)),
  datumDo: new Date(),
  statusPonude: [],
};

const INITIAL_VALUES = {
  id: 0,
  ceoBrDok: '',
  datum: formatDateBody(new Date()),
  idMasine: null,
  nazivMasine: '',
  idVeze: null,
  ukupanIznos: 0.0,
  napomena: '',
  files: [],
  base64: '',
  brZahteva: '',
};

const Ponude = ({ novi, handleNovi, handleDisableBtnNovi }) => {
  const { t, i18n } = useTranslation();
  const { tabsData, activeComponent, onTabChange } = useContext(TabContext);
  const { addTab } = useContext(TabContext);
  const dataLocal = tabsData.find((item) => item.type === activeComponent);
  const ponudaLocal = dataLocal?.data ? dataLocal?.data : null;
  const { getData, isLoading } = useHttp('');
  const [gridData, setGridData] = useState([]);
  const [filterValues, setFilterValues] = useState(INITIAL_VALUES_FILTER);
  const [openDialog, setOpenDialog] = useState(false);
  const [formValue, setFormValue] = useState(INITIAL_VALUES);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [naziv, setNaziv] = useState('');
  const [tip, setTip] = useState('');

  const vratiGridPonude = async (initList = null) => {
    // // console.log(initList);
    const config = {
      url: urls.GET_PONUDE,
      method: 'POST',
      data: {
        datumOd: filterValues.datumOd,
        datumDo: filterValues.datumDo,
        lista: initList !== null ? initList : filterValues.statusPonude,
        idKupca: +localStorage.idFirme,
        idKorProm: +localStorage.idKorisnika,
        metadata: i18n.language,
      },
    };
    const response = await getData(config);
    // // console.log(response);
    if (response) {
      setGridData(response);
    }
  };
  useEffect(() => {
    if (localStorage.idFirme !== '1') {
      handleDisableBtnNovi({ id: activeComponent, disabled: true });
    }
  }, []);

  const handlePretrazi = () => {
    vratiGridPonude();
  };

  useEffect(() => {
    if (novi) {
      setOpenDialog(true);
    }
    handleNovi(false);
  }, [novi]);

  const handleOpenDialog = (id) => {
    setOpenDeleteDialog(true);
    setFormValue({ ...INITIAL_VALUES, id: id });
  };

  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_PONUDE,
      data: {
        id: formValue.id,
      },
    };
    const result = await getData(config);
    if (result > 0) {
      vratiGridPonude();
      setOpenDeleteDialog(false);
      return;
    }
    toast.error(handleErrorMessage(result));
  };

  const handleSave = async () => {
    // // console.log(formValue.slikaUrl);
    const fd = new FormData();
    fd.append('id', formValue.id);
    fd.append('datum', formValue.datum);
    fd.append('idMasine', formValue.idMasine ? formValue.idMasine : 0);
    fd.append('idVeze', formValue.idVeze ? formValue.idVeze : 0);
    fd.append('ukupanIznos', +formValue.ukupanIznos);
    fd.append('napomena', formValue.napomena);
    fd.append('idKorProm', +localStorage.getItem('idKorisnika'));

    for (let i = 0; i < formValue.files.length; i += 1) {
      fd.append('Slika', formValue.files[0]);
    }

    const config = {
      method: 'POST',
      url: formValue.id > 0 ? urls.EDIT_PONUDE : urls.INSERT_PONUDE,
      data: fd,
    };
    const response = await getData(config);
    if (response.id > 0) {
      const message =
        formValue.id > 0 ? 'Uspešna izmena ponude' : 'Uspešan unos ponude';
      toast.success(message);
      vratiGridPonude();
      setOpenDialog(false);
      return;
    }
    toast.error(handleErrorMessage(response));
  };
  const handleClickDokumentKlijenti = (item) => {
    console.log(item);
    const tab = {
      title: 'Detalji ponude',
      icon: 'fas fa-file',
      type: 10017,
      data: { pregledMasina: item },
    };
    addTab(tab);
  };

  const handleClickDokument = async (id, idReda) => {
    let idDok = 0;
    let base64 = '';
    let nazivFajla = '';
    let tipFajla = '';
    const config = {
      method: 'POST',
      url: urls.GET_PONUDE_ID,
      data: { id: id },
    };
    const response = await getData(config);
    if (response?.id) {
      // setFormValue({ ...response, id: response.idDok, files: [] });
      idDok = response.idDok;
      nazivFajla = response.name;
      tipFajla = response.type;
      setNaziv(response.name);
      setTip(response.type);
      setOpenDialog(true);
    }

    const config2 = {
      method: 'POST',
      url: urls.KONVERTOVANJE_BASE_64,
      data: { id: idReda },
    };
    const response2 = await getData(config2);
    // // console.log(response2);
    if (response2 !== 'Nema dokumenta!') {
      base64 = response2;

      const base64ToBlob = (base64, contentType = '', sliceSize = 512) => {
        const byteCharacters = atob(base64);
        const byteArrays = [];

        for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i += 1) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
      };

      const base64ToFile = (base64, filename, contentType) => {
        const blob = base64ToBlob(base64, contentType);
        const file = new File([blob], filename, { type: contentType });
        return file;
      };

      const fileName = nazivFajla;
      const fileType = tipFajla;

      const file = base64ToFile(base64, fileName, fileType);

      setFormValue({
        ...response,
        id: idDok,
        files: [file],
        base64: response2,
      });
    } else if (response2 === 'Nema dokumenta!') {
      setFormValue({ ...response, id: idDok, files: [] });
    } else {
      toast.error('Greška!');
    }
  };
  useEffect(() => {
    console.log(ponudaLocal);
    if (ponudaLocal?.pregledMasina) {
      handleClickDokument(
        ponudaLocal.pregledMasina.idDok,
        ponudaLocal.pregledMasina.id,
      );
      setOpenDialog(true);
      const tab = {
        title: 'Ponude',
        icon: 'fas fa-file',
        type: 74,
        data: { pregledMasina: null },
      };
      onTabChange(tab);
    }
    if (ponudaLocal?.prenetServisnogZahteva) {
      const zahtev = ponudaLocal.prenetServisnogZahteva;
      setFormValue((curr) => {
        return {
          ...curr,
          idVeze: zahtev.idDok,
          idMasine: zahtev.idMasine,
          nazivMasine: zahtev.nazivMasine,
          brZahteva: zahtev.ceoBrDok,
        };
      });
      setOpenDialog(true);
    }
  }, []);

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setFormValue(INITIAL_VALUES);
    setNaziv('');
    setTip('');
  };

  const downloadBase64 = async () => {
    const base64Data = formValue.base64;
    const fileName = formValue.name;

    // Konvertovanje base64 stringa u Blob objekt
    const byteCharacters = atob(base64Data);
    const byteNumbers = Array.from(byteCharacters, (char) =>
      char.charCodeAt(0),
    );
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: 'application/octet-stream',
    });

    // Kreiranje URL-a za Blob objekt
    const blobUrl = URL.createObjectURL(blob);

    // Kreiranje i klikanje na link element za preuzimanje datoteke
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', fileName); // Postavite naziv datoteke
    document.body.appendChild(link);
    link.click();

    // Čišćenje URL-a i uklanjanje linka
    URL.revokeObjectURL(blobUrl);
    document.body.removeChild(link);
  };

  const downloadFile = async (fileName, idReda) => {
    const config = {
      method: 'POST',
      url: urls.KONVERTOVANJE_BASE_64,
      data: { id: idReda },
    };

    const response = await getData(config);
    // // console.log(response);
    if (response !== 'Nema dokumenta!') {
      const base64Data = response; // Pretpostavljam da response.data sadrži base64 string.

      // Konvertovanje base64 stringa u Blob objekt
      const byteCharacters = atob(base64Data);
      const byteNumbers = Array.from(byteCharacters, (char) =>
        char.charCodeAt(0),
      );
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/octet-stream' });

      // Kreiranje URL-a za Blob objekt
      const blobUrl = URL.createObjectURL(blob);

      // Kreiranje i klikanje na link element za preuzimanje datoteke
      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', fileName); // Postavite naziv datoteke
      document.body.appendChild(link);
      link.click();

      // Čišćenje URL-a i uklanjanje linka
      URL.revokeObjectURL(blobUrl);
      document.body.removeChild(link);
    } else if (response === 'Nema dokumenta!') {
      toast.error('Nema dokumenata za preuzimanje');
    } else {
      toast.error('Greška!');
    }
  };
  const handleClickPregledZahteva = (row, id) => {
    console.log(row);
    row.idDok = row.idVeze;
    if (row.vrstaDokVeze === 'SZ') {
      const tab = {
        title: 'Pregled zahteva',
        icon: 'fas fa-clipboard',
        type: 10014,
        data: row,
      };
      addTab(tab);
    }
    if (row.vrstaDokVeze === 'NAR') {
      const handlePorudzina = async () => {
        const config = {
          method: 'POST',
          url: 'DokNarudzbine/vrati_dok_narudzbine_za_id',
          data: { id: row.idVeze },
        };
        const result = await getData(config);
        console.log(result);
        const tab = {
          title: 'Porudžbenica pregled',
          icon: 'fas fa-clipboard',
          type: 10015,
          data: result,
        };
        addTab(tab);
      };
      handlePorudzina();
    }
  };

  return (
    <div>
      {isLoading && <Spinner />}
      <ZaglavljeFilter
        handlePretrazi={handlePretrazi}
        setFilterValues={setFilterValues}
        filterValues={filterValues}
        vratiGridPonude={vratiGridPonude}
      />
      <GridProviderPonude
        data={gridData}
        loading={isLoading}
        handleClickDokumentKlijenti={handleClickDokumentKlijenti}
        handleClickDokument={handleClickDokument}
        handleOpenDialog={handleOpenDialog}
        downloadFile={downloadFile}
        handleClickPregledZahteva={handleClickPregledZahteva}
      />

      <MuiDialog
        maxWidth="xs"
        open={openDeleteDialog}
        title="Upozorenje"
        text="Da li ste sigurni da želite da obrišete izabranu ponudu?"
        handleClose={() => setOpenDeleteDialog(false)}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />

      <MuiDialog
        maxWidth="sm"
        open={openDialog}
        title={formValue.id === 0 ? 'Unos ponude' : 'Izmena ponude'}
        content={
          <Inputs
            formValue={formValue}
            setFormValue={setFormValue}
            naziv={naziv}
            setNaziv={setNaziv}
            downloadFile={downloadBase64}
          />
        }
        handleClose={handleCloseDialog}
        handleConfirm={handleSave}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default Ponude;
